import { Component, NgZone, OnInit, ViewChild } from '@angular/core';
import { FormGroupDirective } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import Enumerable from 'linq';
import { CardTokenViewModel, ConferenceViewModelWithDetails, SponsorshipOrderModel, SponsorStoreSettings, StringViewModel } from 'src/app/_models/generatedModels';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { CallForSponsorsService, OrganizationService } from 'src/app/_services/generatedServices';
import { NavigationService } from 'src/app/_services/navigation-service';
import { SponsorshipCartService } from 'src/app/_services/sponsorship-cart.service';

@Component({
  selector: 'bxl-checkout',
  templateUrl: 'checkout.component.html',
})
export class CheckoutComponent implements OnInit {
  initialized = false;
  @ViewChild('myForm') myForm: FormGroupDirective;
  model: SponsorshipOrderModel;
  submitComplete: Promise<{}> | undefined;
  public cardNumber: string;
  public cardHolder: string;
  public promoCode: string;
  public expMo: string;
  public expYr: string;
  public cvv: string;
  public errorMessage: string;
  conferenceId: string;
  promoError: string;
  adjustedTotal: number;
  creditCardFee: number;
  settings: SponsorStoreSettings;
  conference: ConferenceViewModelWithDetails;

  constructor(public auth: AuthenticationService, private orgService: OrganizationService, private router: Router, private route: ActivatedRoute, private cfsService: CallForSponsorsService, private zone: NgZone, public navService: NavigationService, public cart: SponsorshipCartService) {}

  ngOnInit(): void {
    this.route.paramMap.subscribe((params) => {
      this.conferenceId = params.get('conferenceSlug');

      this.orgService.getConferenceBySlug(this.conferenceId).subscribe((conference) => {
        this.cfsService.getSponsorStoreSettings(this.conferenceId).subscribe((result) => {
          this.settings = result;
          this.conference = conference;
          this.model = new SponsorshipOrderModel();
          this.model.sendInvoice = true;
          this.model.isAdminOrder = false;
          this.model.items = this.cart.items;
          this.model.isPurchaseOrder = false;

          if (!this.settings.allowCreditCardsForSponsorships) {
            this.model.isPurchaseOrder = true;
          }

          this.cart.checkCart(this.conferenceId);
          this.adjustedTotal = this.cart.cartTotal;
          this.creditCardFee = this.adjustedTotal * .03;
          this.initialized = true;
        });
      });
    });
  }



  applyPromoCode() {
    let model = new StringViewModel();
    model.value = this.promoCode;
    this.cfsService.checkPromoCode(this.conferenceId, model).subscribe(
      (result) => {
        this.promoError = '';
        this.adjustedTotal = this.cart.cartTotal - this.cart.cartTotal * (result.discountPercentage / 100);
        this.creditCardFee = this.adjustedTotal * .03;
      },
      (error) => {
        this.promoError = error.error;
      }
    );
  }

  submit() {
    this.errorMessage = '';
    if (!this.myForm.valid) {
      this.myForm.form.markAllControlsDirty();
      return;
    }
    console.log('saving ' + this.myForm.valid);
    console.log(this.model);

    this.submitComplete = new Promise((resetButton: any, reject) => {
      if (this.adjustedTotal == 0 || this.model.isPurchaseOrder) {
        this.completeFree(resetButton);
      } else {
        this.completePaid(resetButton);
      }
    });
  }

  completeFree(resetButton: any) {
    this.model.promoCode = this.promoCode;
    this.zone.run(() => {
      this.cfsService.processSponsorshipOrder(this.conferenceId, this.model).subscribe(
        (result) => {
          this.cart.clear();
          this.router.navigate(['../order-complete'], { relativeTo: this.route });

          resetButton();
        },
        (error) => {
          this.errorMessage = Enumerable.from(error.error).toJoinedString('<br>');
          resetButton();
        }
      );
    });
  }

  completePaid(resetButton: any) {
    let card = { number: this.cardNumber, exp_month: this.expMo, exp_year: this.expYr, cvc: this.cvv };
    (<any>window).Stripe.card.createToken(card, (status: number, response: any) => {
      if (status === 200) {
        this.model.cardToken = response.id;
        this.model.promoCode = this.promoCode;
        this.zone.run(() => {
          this.cfsService.processSponsorshipOrder(this.conferenceId, this.model).subscribe(
            (result) => {
              this.cart.clear();
              this.router.navigate(['../order-complete'], { relativeTo: this.route });

              resetButton();
            },
            (error) => {
              this.errorMessage = Enumerable.from(error.error).toJoinedString('<br>');
              resetButton();
            }
          );
        });
      } else {
        this.zone.run(() => {
          resetButton();
          this.errorMessage = response.error.message;
        });
      }
    });
  }
}
